import request from "../config";

const initialState = {
  dns: {
    isVerifing: false,
    isLoading: true,
    hasValidationFailed: false,
    hasValidationSuccessed: false
  },
  email: {
    isCodeSent: false,
    isLoading: true,
    emails: ["postmaster", "hostmaster", "webmaster", "info"],
    hasValidationFailed: false,
    hasValidationSuccessed: false,
    emailChosen: "",
    isCodeVerifing: false,
    isSendingEmail: false
  },
  html: {
    isGeneratingFile: false,
    fileGenerated: false,
    url: undefined,
    isVerifingFile: false,
    fileVerified: false,
    fileVerificationFailed: false
  }
};

const SKIP_VERIFICATION = "SKIP VERIFICATION";
const RESET_VERIFICATION = "RESET_VERIFICATION";
const SKIPPED = "SKIPPED";
const RESETTED = "RESETTED";
const VERIFY_DNS = "VERIFY_DNS";
const CHECK_DNS_VERIFICATION_STATUS = "CHECK_DNS_VERIFICATION_STATUS";
const SHOW_VERIFICATION_FAILED = "SHOW_VERIFICATION_FAILED";
const SHOW_VERIFICATION_SUCCESSFUL = "SHOW_VERIFICATION_SUCCESSFUL";

const SEND_VERIFICATION_EMAIL = "SEND_VERIFICATION_EMAIL";
const SHOW_CODE_INPUT = "SHOW_CODE_INPUT";
const SET_EMAIL_CHOSEN = "SET_EMAIL_CHOSEN";
const IS_VERIFING_CODE = "IS_VERIFING_CODE";
const SHOW_EMAIL_VERIFICATION_SUCCESSFUL = "SHOW_EMAIL_VERIFICATION_SUCCESSFUL";
const SHOW_EMAIL_VERIFICATION_FAILED = "SHOW_EMAIL_VERIFICATION_FAILED";

const GENERATE_FILE = "GENERATE_FILE";
const FILE_GENERATED = "FILE_GENERATED";
const VERIFY_FILE = "VERIFY_FILE";
const FILE_VERIFIED = "FILE_VERIFIED";
const FILE_VERIFICATION_FAILED = "FILE_VERIFICATION_FAILED";

const RESET_STATE = "RESET_STATE";

export default function(state = initialState, action = {}, initlState = initialState) {
  switch (action.type) {
    case VERIFY_DNS:
      return {
        ...state,
        dns: {
          isVerifing: true,
          isLoading: false,
          hasValidationFailed: false,
          hasValidationSuccessed: false
        }
      };

    case CHECK_DNS_VERIFICATION_STATUS:
      return {
        ...state,
        dns: {
          ...state.dns,
          isVerifing: true,
          isLoading: false,
          hasValidationFailed: false,
          hasValidationSuccessed: false
        }
      };

    case SHOW_VERIFICATION_FAILED:
      return {
        ...state,
        dns: {
          isVerifing: false,
          isLoading: false,
          hasValidationFailed: true,
          hasValidationSuccessed: false
        }
      };

    case SHOW_VERIFICATION_SUCCESSFUL:
      return {
        ...state,
        dns: {
          isVerifing: false,
          isLoading: false,
          hasValidationFailed: false,
          hasValidationSuccessed: true
        }
      };

    case SEND_VERIFICATION_EMAIL:
      return {
        ...state,
        email: {
          ...state.email,
          isSendingEmail: true
        }
      };

    case SHOW_CODE_INPUT:
      return {
        ...state,
        email: {
          ...state.email,
          isSendingEmail: false,
          isCodeSent: true,
          emailChosen: action.emailAddress
        }
      };

    case SET_EMAIL_CHOSEN:
      return {
        ...state,
        email: {
          ...state.email,
          emailChosen: action.emailAddress
        }
      };

    case IS_VERIFING_CODE:
      return {
        ...state,
        email: {
          ...state.email,
          isCodeVerifing: true
        }
      };

    case SHOW_EMAIL_VERIFICATION_FAILED:
      return {
        ...state,
        email: {
          ...state.email,
          isCodeVerifing: false,
          hasValidationFailed: true,
          hasValidationSuccessed: false
        }
      };

    case SHOW_EMAIL_VERIFICATION_SUCCESSFUL:
      return {
        ...state,
        email: {
          ...state.email,
          isCodeVerifing: false,
          hasValidationFailed: false,
          hasValidationSuccessed: true
        }
      };

    case SKIP_VERIFICATION:
      return {
        ...state,
        dns: {
          isSkipping: true
        }
      };

    case RESET_VERIFICATION:
      return {
        ...state,
        email: {
          isResetting: true,
          resetted: false
        }
      };

    case SKIPPED:
      return {
        ...state,
        dns: {
          skipped: true,
          isSkipping: false
        }
      };

    case RESETTED:
      return initlState;
    // return {
    //   ...state,
    //   email: {
    //     resetted: true,
    //     isResetting: false,
    //   }
    // };

    case RESET_STATE:
      return initlState;

    case GENERATE_FILE:
      return {
        ...state,
        html: {
          isGeneratingFile: true,
          fileGenerated: false
        }
      };

    case FILE_GENERATED:
      return {
        ...state,
        html: {
          isGeneratingFile: false,
          fileGenerated: true,
          url: action.url
        }
      };

    case VERIFY_FILE:
      return {
        ...state,
        html: {
          ...state.html,
          isVerifingFile: true,
          fileVerified: false,
          fileVerificationFailed: false
        }
      };

    case FILE_VERIFIED:
      return {
        ...state,
        html: {
          ...state.html,
          isVerifingFile: false,
          fileVerified: true,
          fileVerificationFailed: false
        }
      };

    case FILE_VERIFICATION_FAILED:
      return {
        ...state,
        html: {
          ...state.html,
          isVerifingFile: false,
          fileVerified: false,
          fileVerificationFailed: true
        }
      };

    default:
      return state;
  }
}

export function resetState() {
  return {
    type: RESET_STATE
  };
}

function showEmailVerificationSuccessful() {
  return {
    type: SHOW_EMAIL_VERIFICATION_SUCCESSFUL
  };
}

function showEmailVerificationFailed() {
  return {
    type: SHOW_EMAIL_VERIFICATION_FAILED
  };
}

function showVerificationSuccessful() {
  return {
    type: SHOW_VERIFICATION_SUCCESSFUL
  };
}

function showVerificationFailed() {
  return {
    type: SHOW_VERIFICATION_FAILED
  };
}

function showIsVerifing() {
  return {
    type: VERIFY_DNS
  };
}

function showCodeInput(email) {
  return {
    type: SHOW_CODE_INPUT,
    emailAddress: email
  };
}

function sendingVerificationEmail() {
  return {
    type: SEND_VERIFICATION_EMAIL
  };
}

function setEmailChosen(email) {
  return {
    type: SET_EMAIL_CHOSEN,
    emailAddress: email
  };
}

function isVerifingCode() {
  return {
    type: IS_VERIFING_CODE
  };
}

function showIsSkipping() {
  return {
    type: SKIP_VERIFICATION
  };
}

function skipped() {
  return {
    type: SKIPPED
  };
}

function showIsResetting() {
  return {
    type: RESET_VERIFICATION
  };
}

function resetted() {
  return {
    type: RESETTED
  };
}

export function skipOwnershipCheck(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/skip_ownership_check`;
  } else {
    url = `/domains/${domainCode}/skip_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "PUT",
      url
    };

    dispatch(showIsSkipping());

    return request(config).then(resp => {
      dispatch(skipped());
    });
  };
}

export function resetEmailVerification(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/reset_email_ownership_check`;
  } else {
    url = `/domains/${domainCode}/reset_email_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "PUT",
      url
    };

    dispatch(showIsResetting());

    return request(config).then(resp => {
      dispatch(resetted());
    });
  };
}

export function checkDNSVerificationStatus(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}`;
  } else {
    url = `/domains/${domainCode}`;
  }

  return function(dispatch) {
    const config = {
      method: "GET",
      url
    };

    dispatch(showIsVerifing());

    return request(config).then(resp => {
      const domainStatusDetail = resp.data.resources[0].status_detail;
      const domainStatus = resp.data.resources[0].status;

      if (domainStatus !== "ownership_check") {
        dispatch(showVerificationSuccessful());
        return;
      }

      if (domainStatusDetail === "verifing") {
        dispatch(showIsVerifing());
      } else if (domainStatusDetail === "dns" && domainStatus === "ownership_check") {
        dispatch(showVerificationFailed());
      }
    });
  };
}

export function verifyDNSRecord(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/dns_ownership_check`;
  } else {
    url = `/domains/${domainCode}/dns_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "PUT",
      url
    };
    dispatch(showIsVerifing());
    return request(config).then(resp => {
      dispatch(checkDNSVerificationStatus(domainCode, aliasDomainCode));
    });
  };
}

export function sendVerificationEmail(domainCode, formValues, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/email_ownership_check`;
  } else {
    url = `/domains/${domainCode}/email_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "PUT",
      url,
      data: formValues
    };

    dispatch(sendingVerificationEmail());

    return request(config).then(resp => {
      dispatch(showCodeInput(formValues.verification_email_address));
      // dispatch(setEmailChosen(formValues.verification_email_address))
    });
  };
}

export function verifyCode(domainCode, formValues, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/email_ownership_check`;
  } else {
    url = `/domains/${domainCode}/email_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "POST",
      url,
      data: formValues
    };

    dispatch(isVerifingCode());

    return request(config)
      .then(resp => {
        if (resp.status === 204) {
          dispatch(showEmailVerificationSuccessful());
        }
      })
      .catch(err => {
        if (err.response.status === 422) {
          dispatch(showEmailVerificationFailed());
        }
      });
  };
}

function isGeneratingFile() {
  return {
    type: GENERATE_FILE
  };
}

function fileGenerated(url) {
  return {
    type: FILE_GENERATED,
    url: url
  };
}

function isVerifingFile() {
  return {
    type: VERIFY_FILE
  };
}

function fileVerified(url) {
  return {
    type: FILE_VERIFIED
  };
}

function showFileVerificationFailed() {
  return {
    type: FILE_VERIFICATION_FAILED
  };
}

export function generateFile(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/html_ownership_check`;
  } else {
    url = `/domains/${domainCode}/html_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "POST",
      url
    };

    dispatch(isGeneratingFile());

    return request(config).then(resp => {
      if (resp.status === 201) {
        dispatch(fileGenerated(resp.data.file_url));
      }
    });
    // .catch(err => {
    //   if (err.response.status === 422) {
    //     dispatch(showEmailVerificationFailed());
    //   }
    // });
  };
}

export function verifyFile(domainCode, aliasDomainCode = false) {
  let url;
  if (aliasDomainCode !== false) {
    url = `/domains/${domainCode}/aliases/${aliasDomainCode}/html_ownership_check`;
  } else {
    url = `/domains/${domainCode}/html_ownership_check`;
  }

  return function(dispatch) {
    const config = {
      method: "PUT",
      url
    };

    dispatch(isVerifingFile());

    return request(config)
      .then(resp => {
        if (resp.status === 204) {
          dispatch(fileVerified());
        }
      })
      .catch(err => {
        dispatch(showFileVerificationFailed());
      });
  };
}
